import { msg } from "@lingui/core/macro";

export const expiryDateAfterDateRuleMessages = {
	name: msg({ message: "Expiry Date after Date" }),
	description: msg({ message: "Restrict Permit Expiry Date to be after Date" }),
	errors: {
		expiresTooEarly: msg({ message: "Permits must expire on or after {time}" }),
		noEndDate: msg({ message: "Permit must have an end date" }),
	},
} as const;
